import { useIsLightspeedEnabled } from 'restaurantAdmin/hooks/useIsLightspeedEnabled';
import { IconToggleButton } from './floorPlan/IconToggleButton';
import { SplitMergeKebabMenu } from './floorPlan/SplitMergeKebabMenu';
import { ServiceFloorPlanSelector } from './ServiceFloorPlanSelector';
import styles from './ServicePage.scss';
import { useReservationServiceContext } from './state/ReservationServiceContext';

export const PageActions = () => {
  const {
    shouldShowServerBadges,
    shouldShowServiceStatuses,
    shouldShowTableNumbers,
    shouldShowSpend,
    timerDisplayMode,
    toggleShouldShowServerBadges,
    toggleShouldShowServiceStatuses,
    toggleShouldShowTableNumbers,
    toggleShouldShowSpend,
    cycleTimerDisplayMode,
  } = useReservationServiceContext();
  const isLightspeedEnabled = useIsLightspeedEnabled();

  const timerTooltipOverride =
    timerDisplayMode === 'off'
      ? 'Show Time Until Next Reservation'
      : timerDisplayMode === 'countdown'
        ? 'Show Next Reservation Time'
        : 'Hide Timers';

  return (
    <div className={styles.actionsContainer}>
      <div>
        <ServiceFloorPlanSelector />
      </div>
      <div className={styles.actions}>
        {isLightspeedEnabled && (
          <IconToggleButton
            title="Spend"
            iconName="dollarSign"
            checked={shouldShowSpend}
            onClick={toggleShouldShowSpend}
            tooltipContent="Spend"
            dataTooltipId="spend-tooltip"
            place="bottom"
          />
        )}
        <IconToggleButton
          title="Service Statuses"
          iconName="tableStatus"
          checked={shouldShowServiceStatuses}
          onClick={toggleShouldShowServiceStatuses}
          tooltipContent="Service Statuses"
          dataTooltipId="service-statuses-tooltip"
          place="bottom"
        />
        <IconToggleButton
          title="Server Badges"
          iconName="server"
          checked={shouldShowServerBadges}
          onClick={toggleShouldShowServerBadges}
          tooltipContent="Servers"
          dataTooltipId="server-badges-tooltip"
          place="bottom"
        />
        <IconToggleButton
          title="Table Numbers"
          iconName="hashtag"
          checked={shouldShowTableNumbers}
          onClick={toggleShouldShowTableNumbers}
          tooltipContent="Table Numbers"
          dataTooltipId="table-numbers-tooltip"
          place="bottom"
        />
        <IconToggleButton
          title="Timers"
          iconName={timerDisplayMode === 'clockTime' ? 'clock' : 'timer'}
          checked={timerDisplayMode !== 'off'}
          onClick={cycleTimerDisplayMode}
          tooltipContent="Table Timers"
          tooltipContentOverride={timerTooltipOverride}
          dataTooltipId="table-timers-tooltip"
          place="bottom"
          iconClassName={
            timerDisplayMode === 'clockTime' ? styles.clock : undefined
          }
        />
        <SplitMergeKebabMenu />
      </div>
    </div>
  );
};
